var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowDown28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.14645 8.14645C4.34171 7.95118 4.65829 7.95118 4.85355 8.14645L14.5 17.7929L24.1464 8.14645C24.3417 7.95118 24.6583 7.95118 24.8536 8.14645C25.0488 8.34171 25.0488 8.65829 24.8536 8.85355L14.8536 18.8536C14.6583 19.0488 14.3417 19.0488 14.1464 18.8536L4.14645 8.85355C3.95118 8.65829 3.95118 8.34171 4.14645 8.14645Z",
  fill: "currentColor"
})));
export default SvgBigArrowDown28;